import * as React from 'react';
import { Typography, Box, Container, Divider } from '@mui/material';
import { connect } from "react-redux";
import { BrowserView, isMobile, MobileView } from 'react-device-detect';
import { centered_flex_box } from '../app/components/Styles';
import LandingLayout from '../landing/LandingLayout';

export const Terms = () => {
    return (
      <LandingLayout>
        <Container maxWidth="lg" sx={{
            py: isMobile ? 4 : 6,
            color: "#4a444e",
            "& .MuiTypography-h3": { color: "#7D010C" },
            "& .MuiTypography-h5": { color: "#1a1416" },
            "& .MuiTypography-root": { color: "inherit" },
        }}>
            <Box sx={{ ...centered_flex_box, mb: 4 }}>
                <Typography variant="h3" fontWeight={600} sx={{ color: "#7D010C !important" }}>
                    Terms & Conditions
                </Typography>
            </Box>

            <Box sx={{ maxWidth: "900px", mx: "auto" }}>
                {/* Section 1 */}
                <Typography variant="h5" fontWeight={600} mt={4} mb={2}>
                    1. Introduction & Acceptance of Terms
                </Typography>
                <Typography paragraph>
                    These Terms & Conditions ("Terms") govern the provision of services by Chainz Solutions
                    ("Chainz," "we," "us," or "our"), a tech-enabled fulfillment center and logistics solutions provider.
                    By accessing our website, entering into a service agreement, onboarding inventory, or using any
                    of our services, the client ("Client," "you," or "your") acknowledges that it has read, understood,
                    and agreed to be legally bound by these Terms.
                </Typography>
                <Typography paragraph>
                    If the Client does not agree to these Terms, it must refrain from using Chainz Solutions'
                    services.
                </Typography>

                {/* Section 2 */}
                <Typography variant="h5" fontWeight={600} mt={4} mb={2}>
                    2. Definitions & Interpretation
                </Typography>
                <Typography paragraph>
                    For the purposes of these Terms:
                </Typography>
                <Typography component="ul" sx={{ pl: 3 }}>
                    <li>"Services" means all logistics, warehousing, fulfillment, inventory management, order
                        processing, delivery coordination, returns handling, and technology services provided by
                        Chainz.</li>
                    <li>"Inventory" means any goods, products, or materials stored, handled, or processed by
                        Chainz on behalf of the Client.</li>
                    <li>"Agreement" means these Terms together with any commercial agreement, service
                        order, pricing schedule, or written addendum agreed between the parties.</li>
                </Typography>
                <Typography paragraph>
                    Headings are for convenience only and do not affect interpretation.
                </Typography>

                {/* Section 3 */}
                <Typography variant="h5" fontWeight={600} mt={4} mb={2}>
                    3. Scope of Services
                </Typography>
                <Typography paragraph>
                    Chainz Solutions provides end-to-end fulfillment and logistics services, which may include, but
                    are not limited to:
                </Typography>
                <Typography component="ul" sx={{ pl: 3 }}>
                    <li>Warehousing and storage</li>
                    <li>Inventory receiving, handling, and management</li>
                    <li>Order fulfillment and dispatch</li>
                    <li>Last-mile delivery coordination through third parties</li>
                    <li>Returns processing</li>
                    <li>Logistics technology and reporting tools</li>
                </Typography>
                <Typography paragraph>
                    Chainz may perform Services across multiple warehouses, branches, or operational locations.
                    Services are provided strictly in accordance with the applicable Agreement.
                </Typography>

                {/* Section 4 */}
                <Typography variant="h5" fontWeight={600} mt={4} mb={2}>
                    4. Client Obligations & Responsibilities
                </Typography>
                <Typography paragraph>
                    The Client shall:
                </Typography>
                <Typography component="ul" sx={{ pl: 3 }}>
                    <li>Provide accurate, complete, and timely information regarding inventory, orders, and
                        documentation</li>
                    <li>Ensure all inventory complies with applicable laws and regulations</li>
                    <li>Properly package, label, and describe all goods</li>
                    <li>Maintain appropriate insurance coverage for inventory unless otherwise agreed</li>
                    <li>Pay all fees in accordance with agreed terms</li>
                </Typography>
                <Typography paragraph>
                    Chainz shall not be liable for errors or delays resulting from inaccurate or incomplete Client
                    information.
                </Typography>

                {/* Section 5 */}
                <Typography variant="h5" fontWeight={600} mt={4} mb={2}>
                    5. Inventory Handling, Storage & Risk Allocation
                </Typography>
                <Typography paragraph>
                    Chainz shall exercise commercially reasonable care in handling and storing inventory.
                </Typography>
                <Typography paragraph>
                    Unless otherwise agreed in writing, risk of loss, damage, or deterioration of inventory remains
                    with the Client at all times, including while inventory is stored at Chainz facilities.
                </Typography>
                <Typography paragraph>
                    Chainz is not an insurer and does not provide insurance coverage for Client inventory.
                </Typography>

                {/* Section 6 */}
                <Typography variant="h5" fontWeight={600} mt={4} mb={2}>
                    6. Order Fulfillment & Delivery Disclaimer
                </Typography>
                <Typography paragraph>
                    Chainz shall use reasonable efforts to fulfill orders based on Client instructions.
                </Typography>
                <Typography paragraph>
                    Delivery timelines are estimates only and may be affected by third-party carriers, force majeure
                    events, or operational constraints.
                </Typography>
                <Typography paragraph>
                    Chainz does not guarantee delivery times and shall not be liable for delays, missed delivery
                    windows, or carrier-related failures.
                </Typography>

                {/* Section 7 */}
                <Typography variant="h5" fontWeight={600} mt={4} mb={2}>
                    7. Service Levels & Performance Limitations
                </Typography>
                <Typography paragraph>
                    Any service levels, performance metrics, or KPIs shall apply only if explicitly agreed in writing.
                    Failure to meet non-contractual service expectations shall not constitute a breach of these
                    Terms.
                </Typography>
                <Typography paragraph>
                    Chainz does not guarantee uninterrupted or error-free operations.
                </Typography>

                {/* Section 8 */}
                <Typography variant="h5" fontWeight={600} mt={4} mb={2}>
                    8. Pricing, Fees, Invoicing & Payment Terms
                </Typography>
                <Typography paragraph>
                    All fees are charged according to the applicable pricing agreement.
                </Typography>
                <Typography paragraph>
                    Invoices are payable within the agreed payment period. Late payments may result in service
                    suspension and/or administrative charges.
                </Typography>
                <Typography paragraph>
                    All fees are exclusive of taxes, duties, or governmental charges, which shall be borne by the
                    Client.
                </Typography>

                {/* Section 9 */}
                <Typography variant="h5" fontWeight={600} mt={4} mb={2}>
                    9. Subscriptions, Renewals & Modifications
                </Typography>
                <Typography paragraph>
                    Subscription-based services shall renew automatically unless terminated in accordance with the
                    Agreement.
                </Typography>
                <Typography paragraph>
                    Chainz reserves the right to modify service offerings, pricing structures, or operational
                    processes with reasonable notice, subject to contractual obligations.
                </Typography>

                {/* Section 10 */}
                <Typography variant="h5" fontWeight={600} mt={4} mb={2}>
                    10. Intellectual Property & Systems Ownership
                </Typography>
                <Typography paragraph>
                    All systems, software, processes, data structures, and intellectual property used or developed
                    by Chainz remain the exclusive property of Chainz Solutions.
                </Typography>
                <Typography paragraph>
                    The Client receives a limited, non-transferable right to use Chainz systems solely for accessing
                    Services.
                </Typography>

                {/* Section 11 */}
                <Typography variant="h5" fontWeight={600} mt={4} mb={2}>
                    11. Confidentiality & Data Protection
                </Typography>
                <Typography paragraph>
                    Each party shall treat all confidential information received from the other party as strictly
                    confidential.
                </Typography>
                <Typography paragraph>
                    Chainz shall process Client data in accordance with applicable data protection laws and internal
                    security policies.
                </Typography>
                <Typography paragraph>
                    Confidentiality obligations survive termination of the Agreement.
                </Typography>

                {/* Section 12 */}
                <Typography variant="h5" fontWeight={600} mt={4} mb={2}>
                    12. Technology Platform Usage
                </Typography>
                <Typography paragraph>
                    Where Chainz provides access to digital platforms or dashboards, such access is granted on an
                    "as-is" basis.
                </Typography>
                <Typography paragraph>
                    Chainz may suspend or restrict access for security, maintenance, or compliance reasons
                    without liability.
                </Typography>

                {/* Section 13 */}
                <Typography variant="h5" fontWeight={600} mt={4} mb={2}>
                    13. Liability Limitations & Indemnification
                </Typography>
                <Typography paragraph>
                    To the maximum extent permitted by law:
                </Typography>
                <Typography component="ul" sx={{ pl: 3 }}>
                    <li>Chainz shall not be liable for indirect, incidental, consequential, or special damages</li>
                    <li>Chainz's total liability shall not exceed the fees paid by the Client in the three (3) months
                        preceding the claim</li>
                </Typography>
                <Typography paragraph>
                    The Client agrees to indemnify and hold Chainz harmless against claims arising from Client
                    inventory, instructions, or legal non-compliance.
                </Typography>

                {/* Section 14 */}
                <Typography variant="h5" fontWeight={600} mt={4} mb={2}>
                    14. Force Majeure
                </Typography>
                <Typography paragraph>
                    Chainz shall not be liable for failure or delay caused by events beyond its reasonable control,
                    including but not limited to natural disasters, labor disputes, government actions, or
                    transportation disruptions.
                </Typography>

                {/* Section 15 */}
                <Typography variant="h5" fontWeight={600} mt={4} mb={2}>
                    15. Termination & Suspension of Services
                </Typography>
                <Typography paragraph>
                    Chainz may suspend or terminate Services for non-payment, legal risk, or material breach by
                    the Client.
                </Typography>
                <Typography paragraph>
                    Termination does not relieve the Client of outstanding payment obligations.
                </Typography>

                {/* Section 16 */}
                <Typography variant="h5" fontWeight={600} mt={4} mb={2}>
                    16. Compliance with Laws & Regulations
                </Typography>
                <Typography paragraph>
                    The Client warrants that all inventory and activities comply with applicable Egyptian laws and
                    regulations.
                </Typography>
                <Typography paragraph>
                    Chainz may refuse to handle goods that pose legal, safety, or regulatory risks.
                </Typography>

                {/* Section 17 */}
                <Typography variant="h5" fontWeight={600} mt={4} mb={2}>
                    17. Dispute Resolution & Governing Law
                </Typography>
                <Typography paragraph>
                    These Terms shall be governed by and construed in accordance with the laws of the Arab
                    Republic of Egypt.
                </Typography>
                <Typography paragraph>
                    Any disputes shall be subject to the exclusive jurisdiction of the competent courts of Egypt.
                </Typography>

                {/* Section 18 */}
                <Typography variant="h5" fontWeight={600} mt={4} mb={2}>
                    18. Amendments & Updates to Terms
                </Typography>
                <Typography paragraph>
                    Chainz reserves the right to update these Terms at any time. Updated Terms shall be effective
                    upon publication on the website.
                </Typography>

                {/* Section 19 */}
                <Typography variant="h5" fontWeight={600} mt={4} mb={2}>
                    19. Entire Agreement & Severability
                </Typography>
                <Typography paragraph>
                    These Terms constitute the entire agreement between the parties regarding website and
                    general service use.
                </Typography>
                <Typography paragraph>
                    If any provision is held unenforceable, the remaining provisions shall remain in full force and
                    effect.
                </Typography>

                {/* Section 20 */}
                <Typography variant="h5" fontWeight={600} mt={4} mb={2}>
                    20. Contact Information
                </Typography>
                <Typography paragraph>
                    Chainz Solutions
                </Typography>
                <Typography paragraph>
                    For legal or contractual inquiries, please contact us through the official communication channels
                    listed on our website.
                </Typography>

                <Divider sx={{ my: 6 }} />

                {/* Returns & Exchange Policy */}
                <Box sx={{ ...centered_flex_box, mb: 4 }}>
                    <Typography variant="h3" fontWeight={600}>
                        Returns & Exchange Policy
                    </Typography>
                </Box>

                {/* Returns Section 1 */}
                <Typography variant="h5" fontWeight={600} mt={4} mb={2}>
                    1. Purpose of This Policy
                </Typography>
                <Typography paragraph>
                    This Returns & Exchange Policy outlines the terms under which Chainz Solutions ("Chainz,"
                    "we," "us") manages product returns, exchanges, and reverse logistics on behalf of its clients
                    ("Client," "you").
                </Typography>
                <Typography paragraph>
                    This policy applies to all inventory processed, stored, or fulfilled by Chainz Solutions unless
                    otherwise agreed in writing.
                </Typography>

                {/* Returns Section 2 */}
                <Typography variant="h5" fontWeight={600} mt={4} mb={2}>
                    2. Scope of Services
                </Typography>
                <Typography paragraph>
                    Chainz Solutions provides returns handling and exchange logistics as an operational service
                    only.
                </Typography>
                <Typography paragraph>
                    Chainz does not determine, approve, or reject return or exchange eligibility unless explicitly
                    authorized by the Client.
                </Typography>
                <Typography paragraph>
                    All return and exchange rules are defined by the Client's own commercial policies toward its end
                    customers.
                </Typography>

                {/* Returns Section 3 */}
                <Typography variant="h5" fontWeight={600} mt={4} mb={2}>
                    3. Client Responsibility for Return & Exchange Rules
                </Typography>
                <Typography paragraph>
                    The Client is solely responsible for:
                </Typography>
                <Typography component="ul" sx={{ pl: 3 }}>
                    <li>Defining return and exchange eligibility criteria</li>
                    <li>Determining time limits, refund methods, and exchange conditions</li>
                    <li>Ensuring return policies are legally compliant and clearly communicated to end
                        customers</li>
                </Typography>
                <Typography paragraph>
                    Chainz executes returns strictly based on Client-provided instructions and shall not be liable for
                    customer dissatisfaction or policy disputes.
                </Typography>

                {/* Returns Section 4 */}
                <Typography variant="h5" fontWeight={600} mt={4} mb={2}>
                    4. Return Authorization Process
                </Typography>
                <Typography paragraph>
                    All returns must be pre-authorized by the Client through one of the following methods:
                </Typography>
                <Typography component="ul" sx={{ pl: 3 }}>
                    <li>Approved return requests submitted via Chainz systems</li>
                    <li>Written operational instructions</li>
                    <li>Integrated platform workflows</li>
                </Typography>
                <Typography paragraph>
                    Unauthorized or unidentified returns may be rejected, quarantined, or processed at the Client's
                    expense.
                </Typography>

                {/* Returns Section 5 */}
                <Typography variant="h5" fontWeight={600} mt={4} mb={2}>
                    5. Condition Assessment of Returned Items
                </Typography>
                <Typography paragraph>
                    Upon receipt, returned items may be classified as:
                </Typography>
                <Typography component="ul" sx={{ pl: 3 }}>
                    <li>Resalable</li>
                    <li>Non-resalable</li>
                    <li>Damaged</li>
                    <li>Defective</li>
                </Typography>
                <Typography paragraph>
                    Chainz performs basic visual and quantity checks only and does not conduct technical,
                    functional, or quality testing unless contractually agreed.
                </Typography>
                <Typography paragraph>
                    Final disposition decisions remain the responsibility of the Client.
                </Typography>

                {/* Returns Section 6 */}
                <Typography variant="h5" fontWeight={600} mt={4} mb={2}>
                    6. Exchanges
                </Typography>
                <Typography paragraph>
                    Exchanges are processed only if:
                </Typography>
                <Typography component="ul" sx={{ pl: 3 }}>
                    <li>The Client has explicitly enabled exchange workflows</li>
                    <li>Replacement inventory is available</li>
                    <li>Clear exchange instructions are provided</li>
                </Typography>
                <Typography paragraph>
                    Chainz is not responsible for stock shortages, pricing differences, or exchange eligibility
                    disputes.
                </Typography>

                {/* Returns Section 7 */}
                <Typography variant="h5" fontWeight={600} mt={4} mb={2}>
                    7. Handling of Damaged, Defective, or Unsellable Items
                </Typography>
                <Typography paragraph>
                    Returned items deemed damaged, defective, expired, or unsellable shall be handled according
                    to Client instructions, which may include:
                </Typography>
                <Typography component="ul" sx={{ pl: 3 }}>
                    <li>Return to Client</li>
                    <li>Disposal</li>
                    <li>Quarantine</li>
                    <li>Write-off</li>
                </Typography>
                <Typography paragraph>
                    If no instructions are provided within a reasonable timeframe, Chainz reserves the right to take
                    commercially reasonable action at the Client's cost.
                </Typography>

                {/* Returns Section 8 */}
                <Typography variant="h5" fontWeight={600} mt={4} mb={2}>
                    8. Inventory Adjustments & Reporting
                </Typography>
                <Typography paragraph>
                    All processed returns and exchanges will be reflected in inventory records based on actual
                    received quantities and assessed condition.
                </Typography>
                <Typography paragraph>
                    Chainz reports operational data but does not guarantee reconciliation with Client sales platforms
                    due to external system dependencies.
                </Typography>

                {/* Returns Section 9 */}
                <Typography variant="h5" fontWeight={600} mt={4} mb={2}>
                    9. Fees & Charges
                </Typography>
                <Typography paragraph>
                    Returns and exchanges may incur additional fees, including but not limited to:
                </Typography>
                <Typography component="ul" sx={{ pl: 3 }}>
                    <li>Receiving and inspection</li>
                    <li>Repackaging</li>
                    <li>Restocking</li>
                    <li>Disposal or reverse shipping</li>
                </Typography>
                <Typography paragraph>
                    All applicable fees are charged according to the Client's pricing agreement with Chainz.
                </Typography>

                {/* Returns Section 10 */}
                <Typography variant="h5" fontWeight={600} mt={4} mb={2}>
                    10. Risk & Liability
                </Typography>
                <Typography paragraph>
                    Risk of loss or damage to returned inventory remains with the Client at all times.
                </Typography>
                <Typography paragraph>
                    Chainz is not liable for:
                </Typography>
                <Typography component="ul" sx={{ pl: 3 }}>
                    <li>Customer misuse or wear</li>
                    <li>Manufacturing defects</li>
                    <li>Transit damage prior to receipt</li>
                    <li>Incorrect return instructions</li>
                </Typography>
                <Typography paragraph>
                    Chainz's liability, if any, is limited in accordance with the Terms & Conditions.
                </Typography>

                {/* Returns Section 11 */}
                <Typography variant="h5" fontWeight={600} mt={4} mb={2}>
                    11. Third-Party Carriers
                </Typography>
                <Typography paragraph>
                    Chainz may coordinate return shipments using third-party carriers.
                </Typography>
                <Typography paragraph>
                    Chainz is not responsible for delays, losses, or damages caused by third-party logistics
                    providers.
                </Typography>

                {/* Returns Section 12 */}
                <Typography variant="h5" fontWeight={600} mt={4} mb={2}>
                    12. Compliance & Restricted Items
                </Typography>
                <Typography paragraph>
                    The Client warrants that returned items comply with all applicable laws and regulations.
                </Typography>
                <Typography paragraph>
                    Chainz reserves the right to refuse or isolate items that pose safety, legal, or regulatory risks.
                </Typography>

                {/* Returns Section 13 */}
                <Typography variant="h5" fontWeight={600} mt={4} mb={2}>
                    13. Policy Modifications
                </Typography>
                <Typography paragraph>
                    Chainz Solutions reserves the right to update this Returns & Exchange Policy at any time.
                    Updates become effective upon publication on the website unless otherwise contractually
                    restricted.
                </Typography>

                {/* Returns Section 14 */}
                <Typography variant="h5" fontWeight={600} mt={4} mb={2}>
                    14. Governing Law
                </Typography>
                <Typography paragraph>
                    This policy is governed by the laws of the Arab Republic of Egypt and shall be interpreted in
                    accordance with applicable regulations.
                </Typography>

                {/* Returns Section 15 */}
                <Typography variant="h5" fontWeight={600} mt={4} mb={2}>
                    15. Contact Information
                </Typography>
                <Typography paragraph>
                    For operational or policy-related inquiries regarding returns and exchanges, Clients should
                    contact Chainz Solutions through official communication channels listed on the website.
                </Typography>
            </Box>
        </Container>
      </LandingLayout>
    );
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Terms);
